import { buildAssistantHeaders, buildAssistantUrl } from "./assistantApi";

export type AssistantSegmentsChangedPayload = {
  marketIds: number[];
  op: "create" | "update" | "delete" | "unknown";
  segmentId?: number | string | null;
};

const normalizeMarketIds = (marketIds: number[]) =>
  Array.from(new Set((marketIds || []).map((id) => Number(id)).filter(Number.isFinite))).sort(
    (a, b) => a - b
  );

export const notifyAssistantSegmentsChanged = async (
  payload: AssistantSegmentsChangedPayload
) => {
  // No token gate here. `buildAssistantHeaders` asks the auth seam, which is
  // the only thing that knows where the token lives — under Auth0 it is in
  // the SDK's own cache and there is no `token` key at all, so reading one
  // meant this notification silently never fired.

  const normalizedPayload = {
    ...payload,
    marketIds: normalizeMarketIds(payload.marketIds),
  };

  const response = await fetch(buildAssistantUrl("segments/changed/"), {
    method: "POST",
    headers: await buildAssistantHeaders(),
    credentials: "include",
    body: JSON.stringify(normalizedPayload),
  });

  if (!response.ok) {
    throw new Error(`segments/changed failed with status ${response.status}`);
  }

  return response.json();
};
